import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
// import { generatePresignedUrl } from "../../utils/helper/generatePresignedUrl";
import { useSelector } from "react-redux";
import { selectSiteLogo, selectSiteName } from "../AsianExchangeSrc/utils/helper/commonSelectors";
import { generatePresignedUrl } from "../AsianExchangeSrc/utils/helper/generatePresignedUrl";

const SiteLogo = ({
  s3Key,             // Optional: Can be passed directly
  className = "sm:h-16 h-14",
  to = "/",
  alt = window.location.hostname, // Optional: fallback to siteName
  defaultSrc = "",  // Optional fallback image
}) => {
  const [logoUrl, setLogoUrl] = useState("");
  const siteLogo = useSelector(selectSiteLogo());
  const siteName = useSelector(selectSiteName());

  useEffect(() => {
    const fetchLogo = async () => {
      try {
        const key = s3Key || siteLogo;
        if (key) {
          const presigned = await generatePresignedUrl(key);
          setLogoUrl(presigned);
        }
      } catch (error) {
        console.error("Error loading site logo:", error);
      }
    };

    fetchLogo();
  }, [s3Key, siteLogo]);

  if (!logoUrl && !defaultSrc) return null;

  return (
    <Link to={to}>
      <img
        src={logoUrl || defaultSrc}
        alt={alt || siteName || "Site Logo"}
        className={`${className} xs:max-w-[115px] sm:max-w-[140px] md:max-w-[155px] xl:max-w-[165px] object-contain`}
        loading="lazy"
      />
    </Link>
  );
};

export default SiteLogo;
